// logicToolState.js
// The label shown on a Logic Assistant tool chip, derived from the tool and
// the stream event that last touched it. Used for the live stream and for the
// durable transcript alike (the backend records each part's ending `event`),
// so an exploration reads "Exploration completed" before and after a reload,
// and only an implement call reads as implementation (L57). Any other tool
// keeps the label the backend supplied.

// The data-investigation tools end with the completion label the backend
// supplies, so only their running label is set here.
const INVESTIGATION_RUNNING_LABELS = {
  get_cell_lineage: 'Tracing data lineage...',
  get_unit: 'Retrieving unit details...',
  get_file: 'Retrieving file details...',
  load_file_to_sandbox: 'Loading source file...',
  search_data_references: 'Searching data references...',
};

export const toolState = (tool, eventType, fallback) => {
  // A model response can end before execution. The backend closes that
  // pending call with its explanation, not a successful code-execution event.
  if (eventType === 'tool_complete') return fallback;
  if (eventType === 'tool_start' && INVESTIGATION_RUNNING_LABELS[tool]) {
    return INVESTIGATION_RUNNING_LABELS[tool];
  }
  if (tool === 'explore_python') {
    if (eventType === 'tool_start') return 'Exploring with Python...';
    if (eventType === 'code_error') return 'Exploration failed with an error';
    return 'Exploration completed';
  }
  if (tool === 'implement_node_logic') {
    if (eventType === 'tool_start') return 'Implementing node logic...';
    if (eventType === 'code_error') return 'Implementation failed with an error';
    return 'Node logic implementation completed';
  }
  return fallback;
};
